import {createAction, props} from '@ngrx/store';
import {StoreModules} from '@shared/enums/store';
import {getModuleActionName} from '@shared/helpers/store/actions.helper';
import {Payload} from '@shared/interfaces/store.interfaces';
import {ChangeUrlParams, GoParams, SetQueryParams} from '@entities/router/router.interfaces';

/**
 * Auxiliary Module name variable for creating unique actions.
 */
const moduleName = StoreModules.Router;
/**
 * Auxiliary function for get the module action name.
 */
const createActionName = getModuleActionName(moduleName);

/**
 * Auxiliary variable with declaration type of actions for Dashboard Actions Page.
 */
const types = {
	go: createActionName('Go'),
	changeUrl: createActionName('Change url'),
	setQueryParams: createActionName('Set query params'),
	clickPageButton: createActionName('Click page button'),
};

/**
 * Auxiliary export declaration actions for Dashboard Actions Page.
 */
export const routerActions = {
	go: createAction(types.go, props<Payload<GoParams>>()),
	changeUrl: createAction(types.changeUrl, props<Payload<ChangeUrlParams>>()),
	setQueryParams: createAction(types.setQueryParams, props<Payload<SetQueryParams>>()),
	clickPageButton: createAction(types.clickPageButton),
};
